import { useState } from 'react'
import {
  Configuration,
  EcommerceApi,
  FinanceGetInvoiceDetailResponse,
  FinanceInvoiceListResponseItem,
  InvoiceDirectionEnum,
  InvoiceFinanceSortFieldEnum,
  InvoiceStatusEnum,
  PaymentsVerifyRequest,
} from 'generated/api'
import { axiosDefaultConfig } from 'constants/axios'
import { AxiosError } from 'axios'
import { useNavigate } from 'react-router-dom'
import Toast from 'components/toast/Toast'

const axiosConfig = new Configuration(axiosDefaultConfig)
const ecommerceApiFp = new EcommerceApi(axiosConfig)

export const useInvoice = () => {
  const [invoiceNumber, setInvoiceNumber] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { toast, toastContainer } = Toast()
  const [failed, setFailed] = useState(false)
  const [status, setStatus] = useState<InvoiceStatusEnum | undefined>(undefined)
  const [sortField, setSortField] = useState<InvoiceFinanceSortFieldEnum>('orderCreatedAt')
  const [sortBy, setSortBy] = useState<InvoiceDirectionEnum>('DESC')
  // state of modal, and button order status
  const [isModalConfirm, setIsModalConfirm] = useState<boolean>(false)
  const [isLoadingConfirm, setIsloadingConfirm] = useState(false)
  const [listInvoice, setListInvoice] = useState<FinanceInvoiceListResponseItem[]>([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalRows, setTotalRows] = useState(0)
  // invoice detail state
  const [detailInvoice, setDetailInvoice] = useState<FinanceGetInvoiceDetailResponse>()
  const [detailInvoiceErr, setDetailInvoiceErr] = useState(0)

  const fetchDataDetail = async (id: string) => {
    try {
      setLoading(true)
      setFailed(false)
      const { data } = await ecommerceApiFp.financeGetInvoiceDetail(id)
      setDetailInvoice(data)
      setLoading(false)
      setFailed(false)
    } catch (e) {
      const error = e as AxiosError
      const responseStatus = error.response?.status
      setDetailInvoiceErr(responseStatus ?? 500)
      setLoading(false)
      setFailed(true)
    }
  }

  const fetchData = async () => {
    try {
      setLoading(true)
      setFailed(false)
      const { data } = await ecommerceApiFp.financeInvoiceList(
        status,
        invoiceNumber,
        page,
        limit,
        sortField,
        sortBy,
      )
      setListInvoice(data.items)
      setTotalRows(data.pagination?.total)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      setFailed(true)
    }
  }

  const handleSort = (field: InvoiceFinanceSortFieldEnum) => {
    if (field === sortField) {
      setSortBy(sortBy === 'ASC' ? 'DESC' : 'ASC')
    } else {
      setSortField(field)
      setSortBy('ASC')
    }
  }

  const handleChangeLimitInvoice = (limit: number) => {
    setLimit(limit)
    setPage(1)
  }

  const handleChangePageInvoice = (page: number) => {
    setPage(page)
  }

  const handleChangeStatus = (status: InvoiceStatusEnum | undefined) => {
    setStatus(status)
    setPage(1)
  }

  const handleSearchInvoice = () => {
    if (page > 1) setPage(1)
    else fetchData()
  }

  const invoiceConfirm = async (request: PaymentsVerifyRequest) => {
    try {
      setIsloadingConfirm(true)
      await ecommerceApiFp.paymentsVerify(request)
      setIsloadingConfirm(false)
      setIsModalConfirm(false)
      navigate('/invoices/list', {
        state: {
          noInvoice: detailInvoice?.invoiceNo,
          name: detailInvoice?.customerName,
          actionType: 'confirm-invoice',
        },
        replace: true,
      })
    } catch (e) {
      toast('Tidak dapat terhubung ke server, silakan mencoba kembali.', 'danger')
      setIsloadingConfirm(false)
      setIsModalConfirm(false)
    }
  }

  return {
    loading,
    failed,
    listInvoice,
    page,
    limit,
    totalRows,
    status,
    invoiceNumber,
    sortField,
    sortBy,
    detailInvoice,
    detailInvoiceErr,
    isModalConfirm,
    isLoadingConfirm,
    toastContainer,
    setLoading,
    setFailed,
    setStatus,
    setSortField,
    setSortBy,
    handleSort,
    handleChangeLimitInvoice,
    handleChangePageInvoice,
    handleChangeStatus,
    handleSearchInvoice,
    setInvoiceNumber,
    setIsModalConfirm,
    setIsloadingConfirm,
    invoiceConfirm,
    fetchData,
    fetchDataDetail,
    toast,
  }
}
